import * as React from 'react'
import styled from 'styled-components'

import {
  Columns,
  Column,
  Button
} from '@espoon-voltti/react-components/elements'
import {
  FormField,
  FormEuroField
} from '@espoon-voltti/react-voltti/components/form/input'

import { t } from '../../../../../i18n'

import { eurosMax } from '../../../validation'

interface Props {
  name: string
  canRemove: boolean
  onRemove: () => unknown
  label: 'expenses' | 'incomes'
}

const RowWrapper = styled.div`
  margin-bottom: 20px;
`

const RemoveButtonMargin = styled.div`
  margin-top: 20px;
`

export const TransactionRow = ({ name, label, canRemove, onRemove }: Props) => (
  <RowWrapper data-qa={'transactionRow'}>
    <Columns>
      <Column size={8}>
        <FormField
          required={true}
          label={t([
            'views',
            'form',
            'expensesAndIncomes',
            label,
            'description'
          ])}
          name={`${name}.description`}
          dataQa={'description'}
        />
      </Column>
      <Column>
        <FormEuroField
          required={true}
          label={t(['views', 'form', 'expensesAndIncomes', label, 'amount'])}
          name={`${name}.amount`}
          dataQa={'value'}
          max={eurosMax.euros()}
        />
      </Column>
      <Column size={2}>
        {canRemove && (
          <RemoveButtonMargin>
            <Button width={'full'} onClick={onRemove} dataQa={'remove'}>
              {t(['views', 'form', 'expensesAndIncomes', label, 'delete'])}
            </Button>
          </RemoveButtonMargin>
        )}
      </Column>
    </Columns>
  </RowWrapper>
)
